/** Boşluksuz, büyük harfli IBAN. */
export const normalizeIban = (v: string) => v.replace(/\s+/g, '').toUpperCase()

/** TR IBAN: "TR" + 2 kontrol hanesi + 22 rakam (toplam 26 karakter) ve ISO 13616 mod-97 kontrolü. */
export function isValidTrIban(raw: string) {
  const iban = normalizeIban(raw)
  if (!/^TR\d{24}$/.test(iban)) return false
  const rearranged = iban.slice(4) + iban.slice(0, 4)
  const digits = rearranged.replace(/[A-Z]/g, (c) => String(c.charCodeAt(0) - 55))
  let rem = 0
  for (const ch of digits) rem = (rem * 10 + Number(ch)) % 97
  return rem === 1
}

/** Ekranda gösterim: "TR12 **** **** **** **** **48 21" yerine okunaklı maske: ilk 4 + son 4. */
export const maskIban = (raw: string) => {
  const iban = normalizeIban(raw)
  return iban ? `${iban.slice(0, 4)} •••• •••• •••• •••• ${iban.slice(-4)}` : ''
}

/** 4'lü gruplar halinde gösterim. */
export const formatIban = (raw: string) => normalizeIban(raw).replace(/(.{4})/g, '$1 ').trim()
